export default class WebshopMenuDropdown {
    constructor($el) {
        this.$el = $el;
        this.trigger = this.$el.querySelector('[data-webshop-menu-dropdown-trigger]');
        this.list = this.$el.querySelector('[data-webshop-menu-dropdown-list]');
        this.openClass = 'webshop-menu__select--open';

        this.toggleList = this.toggleList.bind(this);
        this.closeList = this.closeList.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);

        if (!this.trigger || !this.list) {
            return;
        }

        this.trigger.addEventListener('click', this.toggleList);
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeyDown);
    }

    toggleList(e) {
        e.preventDefault();

        if (this.list.classList.contains(this.openClass)) {
            this.closeList();
            return;
        }

        this.list.classList.add(this.openClass);
        this.trigger.setAttribute('aria-expanded', 'true');
    }

    closeList() {
        this.list.classList.remove(this.openClass);
        this.trigger.setAttribute('aria-expanded', 'false');
    }

    onDocumentClick(e) {
        if (this.$el.contains(e.target)) {
            return;
        }

        this.closeList();
    }

    onKeyDown(e) {
        if (e.key !== 'Escape') {
            return;
        }

        this.closeList();
    }
}
